import { BaseTag } from '@praetorian-chariot/ui';

import { cn } from '@/utils/classname';

export const ScanStatusTag = ({
  isFrozen,
  className,
}: {
  isFrozen: boolean;
  className?: string;
}) => {
  if (isFrozen) {
    return (
      <BaseTag
        size="sm"
        className={cn(
          'border-chariot-stroke-critical bg-chariot-status-critical',
          className
        )}
      >
        Paused
      </BaseTag>
    );
  }

  return (
    <BaseTag
      size="sm"
      className={cn(
        'border-chariot-stroke-info bg-chariot-status-info',
        className
      )}
    >
      Active
    </BaseTag>
  );
};
